import React from "react";

// The three image-source intents, shared by the AI Studio and the swipe-deck
// generator. Maps to two backend flags:
//   "none"      -> generate_images = false
//   "photos"    -> generate_images = true,  generate_ai_images = false
//   "photos_ai" -> generate_images = true,  generate_ai_images = true (default)
//
// "Reference materials" deliberately covers ANY selected Knowledge Hub document
// (uploads, imported web pages, pre-existing files) with extractable photos —
// not just uploads/links — so the copy stays origin-neutral.
export const IMAGE_SOURCE_MODES = [
  {
    value: "photos_ai",
    label: "Photos + AI",
    description: "Reuse real photos, generate the rest",
  },
  {
    value: "photos",
    label: "Photos only",
    description: "Reuse photos from your reference materials",
  },
  {
    value: "none",
    label: "No images",
    description: "Text only",
  },
];

// Derive the two request flags from a mode value.
export function imageModeToFlags(mode) {
  return {
    generate_images: mode !== "none",
    generate_ai_images: mode === "photos_ai",
  };
}

// Inverse: derive a mode from the two flags (NULL = on, matching the backend's
// `is not False` reads).
export function flagsToImageMode(generateImages, generateAiImages) {
  if (generateImages === false) return "none";
  if (generateAiImages === false) return "photos";
  return "photos_ai";
}

export default function ImageSourceControl({ value, onChange, label = "Images" }) {
  return (
    <div>
      {label ? (
        <label className="block text-xs font-semibold text-slate-700 uppercase tracking-wide mb-2">
          {label}
        </label>
      ) : null}
      <div className="grid grid-cols-3 gap-2">
        {IMAGE_SOURCE_MODES.map((opt) => {
          const active = value === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => onChange(opt.value)}
              className={[
                "rounded-lg p-2 text-xs text-center border-2 transition-colors",
                active
                  ? "border-violet-600 bg-violet-50 text-violet-700"
                  : "border-slate-200 hover:border-slate-300 text-slate-700",
              ].join(" ")}
            >
              <div className="font-semibold">{opt.label}</div>
              <div className="text-[10px] text-slate-500 mt-0.5 leading-tight">
                {opt.description}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
